import { NgModule } from '@angular/core';
import { ChartsComponent } from './charts.component';
import { ChartModule } from 'primeng/chart';
import { CommonModule } from '@angular/common';
import { TypographyComponentModule } from '../typography/typography.module';

@NgModule({
  declarations: [ChartsComponent],
  imports: [CommonModule, ChartModule, TypographyComponentModule],
  exports: [ChartsComponent],
})
export class ChartsComponentModule {}
